module.exports = __webpack_public_path__ + "img/bin.23f689e5.png";